import axios from "axios";
import { utils } from "../../utils";



// load all categories
const ActionProd_List = () => async (dispatch) => {//, getState) => {
  try {

    // TODO: ask why its not refresh the page date 

    // let data = await getState().reducer_product.products;
    // console.log('data2:', data)

    // if (data.length === 0) {
    dispatch({ type: utils.constants.PRODUCT_LIST_REQUEST });
    const { data } = await axios.get(utils.constants.API.API_PRODUCTS);
    // }

    dispatch({
      type: utils.constants.PRODUCT_LIST_SUCCESS,
      payload: data
    });


  } catch (error) {
    dispatch({
      type: utils.constants.PRODUCT_LIST_FAIL,
      payload: error.message
    });
  }
}


const ActionProd_Size_Filter = (products, size) => (dispatch) => {
  try {

    if (size === utils.constants.cSizes[0]) {
      dispatch({
        type: utils.constants.FILTER_PRODUCT_BY_SIZE,
        payload: {
          size: size,
          filterProducts: products // all prod
        }
      })
    }
    else if (utils.constants.cSizes.indexOf(size) < 0) {
      throw new Error('Input Error:  Size not as utils.constants.cSizes')
    }
    else {
      dispatch({
        type: utils.constants.FILTER_PRODUCT_BY_SIZE,
        payload: {
          size: size,
          filterProducts: products.filter(s => s.availableSizes.indexOf(size) >= 0)
        }
      })

    }

  } catch (error) {
    dispatch({
      type: utils.constants.PRODUCT_LIST_FAIL,
      payload: error.message
    });
  }
}


const ActionProd_Sort = (sort) => (dispatch, getState) => {
  try {
    if (Object.keys(utils.constants.order).indexOf(sort) < 0) {
      throw new Error('Input Error:  filter order not as utils.constants.order')
    }

    const products = getState().reducer_product.products.slice();


    dispatch({
      type: utils.constants.ORDER_PRODUCT_BY_PRICE,
      payload: {
        sort: sort,
        products: products,
        filterProducts: sort === utils.constants.order.None ?
          products :
          products.slice().sort((a, b) =>
            sort === utils.constants.order.Highest ?
              (a.price > b.price ? -1 : 1) :

              sort === utils.constants.order.Lowest ?
                (a.price < b.price ? -1 : 1) :

                sort === utils.constants.order.Latest ?
                  (a._id > b._id ? -1 : 1) :
                  (0) // error
          )
      }
    })
  } catch (error) {
    dispatch({
      type: utils.constants.PRODUCT_LIST_FAIL,
      payload: error.message
    });
  }

}

const ActionProd_SELLER_newProduct = (prodData) => async (dispatch, getState) => {
  try {

    const { user } = getState().reducer_user;
    if (!(user.isSeller || user.isAdmin || user.isSuperAdmin)) {
      return false;
    }

    dispatch({
      type: utils.constants.PRODUCT_SELLER_NEW_REQUEST,
    })

    const { data } = await axios.post(utils.constants.API.API_PRODUCTS, prodData, { withCredentials: true })
    console.log('data:', data)




    
  } catch (error) {
    dispatch({
      type: utils.constants.PRODUCT_LIST_FAIL,
      payload: error.message
    });
  }

}
const ActionProd_Search = (val) => (dispatch, getState) => {
  try {

    const products = getState().reducer_product.products.slice();
    const searchedProducts = products.filter((p) => p.title.indexOf(val) > -1);

    dispatch({
      type: utils.constants.PRODUCT_BY_TXT_SEARCH,
      payload: {
        products,
        searchedProducts
      }
    })

  } catch (error) {
    dispatch({
      type: utils.constants.PRODUCT_LIST_FAIL,
      payload: error.message
    });
  }

}






export {
  ActionProd_List,
  ActionProd_Size_Filter,
  ActionProd_Sort,
  ActionProd_Search,

  ActionProd_SELLER_newProduct,
};